// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".registration-module__container--19wbD{max-width:660px;margin:0 auto}.registration-module__title--1V0N7{margin-bottom:25px}.registration-module__buttonWrapper--2rcUN{margin:40px 0}.registration-module__descriptionBlock--3FiCB{color:#757575;text-align:center}.registration-module__footerText--1Khtb{margin-bottom:5px}.registration-module__benefitRoot--2ZZAj{margin-top:50px;padding:20px;background-color:#eff3fe;border-radius:10px}@media screen and (min-width:1152px){.registration-module__benefitRoot--2ZZAj{padding:30px}}.registration-module__appleButtonWrapper--2vxbW{margin-top:15px}", ""]);
// Exports
exports.locals = {
	"container": "registration-module__container--19wbD",
	"title": "registration-module__title--1V0N7",
	"buttonWrapper": "registration-module__buttonWrapper--2rcUN",
	"descriptionBlock": "registration-module__descriptionBlock--3FiCB",
	"footerText": "registration-module__footerText--1Khtb",
	"benefitRoot": "registration-module__benefitRoot--2ZZAj",
	"appleButtonWrapper": "registration-module__appleButtonWrapper--2vxbW"
};
module.exports = exports;
